import Loader from './Loader'

function MainLayout ({ children }) {
  return (
    <div className=''>
      <Loader />
      <div className=''>{children}</div>
    </div>
  )
}

export default MainLayout
